import { Button, Text } from '@vinted/web-ui';
import Banner from 'components/Banner';
import useTracking from 'hooks/useTracking';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { jsx as _jsx } from "react/jsx-runtime";

const PortalMergeFeedBanner = _ref => {
  let {
    banner,
    screen
  } = _ref;
  const {
    track
  } = useTracking();

  function handleButtonClick() {
    track(clickEvent({
      target: ClickableElement.MergeAnnouncementAction,
      screen
    }));
  }

  const {
    heading,
    text,
    buttonTitle,
    buttonUrl
  } = banner;
  return /*#__PURE__*/_jsx(Banner, {
    title: /*#__PURE__*/_jsx(Text, {
      text: heading,
      type: Text.Type.Heading
    }),
    body: /*#__PURE__*/_jsx(Text, {
      text: text,
      html: true
    }),
    actions: [/*#__PURE__*/_jsx(Button, {
      text: buttonTitle,
      url: buttonUrl,
      styling: Button.Styling.Filled,
      onClick: handleButtonClick
    })]
  });
};

export default PortalMergeFeedBanner;